import * as Yup from "yup";

import { DeleteKEKEndorsementOffer, DeleteKEKEndorsementOfferVariables } from "_graphql/kek/mutation/__generated__/DeleteKEKEndorsementOffer";

import { PopUp } from "components";
import { deleteEndorsementOffer } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useAppSearch } from "_graphql/cache/auth";
import { useMutation } from "@apollo/client";

export const employeeValidationSchema = Yup.object().shape({
  employee_first_name: Yup.string().required("First name is required"),
  employee_last_name: Yup.string().required("Last name is required"),
  employee_phonenumber: Yup.string().required("Phone number is required"),
  employee_email: Yup.string().required("Email is required"),
  employee_position: Yup.string().required("Position is required"),
});

export default function RemoveEndorsementContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const [remove, { loading }] = useMutation<
    DeleteKEKEndorsementOffer,
    DeleteKEKEndorsementOfferVariables
  >(deleteEndorsementOffer, {
    refetchQueries: ["GetKEKEndorsements"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        offerEndorsementDetailId: searchParams?.endorsement_detail_id || "",
        offerEndorsementId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.deleteEndorsementOffer) {
        toast.success("Endorsement removed successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Failed to remove endorsement");
      }
    }).catch((error) => {
      toast.error("Failed to remove endorsement", error?.message);
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Remove Endorsement"
      cancelText="No, Don't Remove Endorsement"
      description="This action would completely remove endorsement details from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Removing Endorsement..." : "Remove Endorsement"}
          </button>
        </>
      )}
    />
  );
}
